/* eslint-disable */
import React from 'react';
import 'contents/assets/scss/page/books.scss';
import Upload from '../../component/Inc/Upload';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
const NoticeDetail = () => {
  return (
    <main className="com_container com_books p_notice_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_1">
            면접 평가
            <span className="bar" />
            <span className="point_txt">상세보기</span>
          </h2>
          <button className="com_btn orange s btn_plus">출간 교재 공지 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <p>
                  조회 <span className="cnt">321</span>
                </p>
                <BtnLike/>
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="input_row">
                <select className="select">
                  <option value="교재 영역 선택">교재 영역 선택</option>
                </select>
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">인쇄교재</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">디지털 교재</label>
                </div>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">한권으로 끝내는 수2가 나왔습니다..</div>
            </div>
            <div className="com_input_wrap">
              <div className="editor light_gray">내용 입력(에디터)</div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />

                <div className="file_info">
                  <div className="file_entry">
                    <select className="select">
                      <option value="정답표">정답표</option>
                    </select>
                    <p className="txt">2022, 08, 25 17:30</p>
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                  <div className="file_entry">
                    <select className="select">
                      <option value="정답표">정답표</option>
                    </select>
                    <p className="txt">2022, 08, 25 17:30</p>
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr className="com_divider" />
            {/*<div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>*/}
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">수정</button>
              <button className="com_btn gray s">삭제</button>
            </div>
          </section>
          <section className="box type_column">
            <div className="detail_tit dot">다운로드 목록 (46571)</div>
            <ul className="com_scroll_list">
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
              <li className="item">
                <span className="sub">2022, 08, 25 17:30</span>
                <span className="tit">홍길동456</span>
              </li>
            </ul>
            <div className="detail_tit dot">관련 댓 글 (5)</div>
            <div className="com_board_box board_scroll">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임105 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">1회 16번 답오류 입니다.</div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임105 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">1회 16번 답오류 입니다.</div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임105</button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">1회 16번 답오류 입니다.</div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임105</button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">1회 16번 답오류 입니다.</div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임105</button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">1회 16번 답오류 입니다.</div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임105</button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">1회 16번 답오류 입니다.</div>
              </div>
              <div className="board_item item_edit">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임105</button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <button className="btn_edit"></button>
                </div>
                <hr className="com_divider" />
                <div className="info">1회 16번 답오류 입니다.</div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <hr className="com_divider" />
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default NoticeDetail;
